import {HttpBackend, HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DownloadFileService {
    private httpClient: HttpClient;
    constructor(
        httpClientHandler: HttpBackend,
    ) {
        this.httpClient = new HttpClient(httpClientHandler); // Create a new instance of HttpClient as BE send complete url (with domain) and we have to bypass the default interceptors
    }

    downloadAdditionaFile(blob: Blob, filename: string, extension: string): void {
        const mimeType = this.getMimeTypeFromExtension(extension);
        this.createFileGeneric(blob, filename, mimeType, extension);
    }

    downloadFile(blob: Blob, filename: string){
        this.createFileGeneric(blob, filename, 'application/pdf', 'pdf');
    }

    downloadCSVFile(blob: Blob, filename: string){
        this.createFileGeneric(blob, filename, 'text/csv', 'csv');
    }

    private createFileGeneric(blob: Blob, filename: string, type: string, extension):void{
        const file = new Blob([blob], { type: type })
        const fileURL = URL.createObjectURL(file);
        const a: HTMLAnchorElement = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = `${filename}.${extension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(fileURL); // Clean up memory
    }

    private static readonly MIME_TYPE_MAP: { [key: string]: string } = {
        pdf: 'application/pdf',
        csv: 'text/csv',
        txt: 'text/plain',
        json: 'application/json',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        zip: 'application/zip',
        mp4: 'video/mp4',
        mp3: 'audio/mpeg',
    };

    private getMimeTypeFromExtension(extension: string): string {
        return DownloadFileService.MIME_TYPE_MAP[extension.toLowerCase()] || 'application/octet-stream';
    }

}
